import React, { useEffect, useState } from 'react'
import { Box, Button, Divider, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Toolbar, Tooltip, Typography, ListItem, ListItemText, List, TablePagination, LinearProgress, Checkbox, CardMedia, Dialog, DialogContent, Link } from '@mui/material';
import { fetchPlatformsList } from '../../store/platformSlice';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLeadById, fetchLeadData } from '../../store/LeadSlice';
import PropTypes from 'prop-types';
import TableSortLabel from '@mui/material/TableSortLabel';
import { visuallyHidden } from '@mui/utils';
import CommentDrawer from '../Common/Drawer';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { ROWS_PER_PAGE, capitalizeWords } from '../../utils/constant';
import Loader from '../Common/Loader';
import { useLocation } from 'react-router-dom';
import { fetchIndustryList } from '../../store/industrySlice';
import { NoData } from '../Common/NoData';
import { fetchClientList } from '../../store/clientSlice';
import LeadExport from '../lead/LeadExport';
import Confirmation from '../Common/Confirmation';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import CommonTabs from '../Common/CommonTabs';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
function createData(uuid, id, name, platform, email, phone, leadType,cateory, commentText, client, replySent, location, soldOn, source, createdat, actions) {
  return {
    uuid,
    id,
    name,
    platform,
    email,
    phone,
    leadType,
    cateory,
    commentText,
    client,
    replySent,
    location,
    soldOn,
    source,
    createdat,
    actions,
  };
}

const headCells = [
  {
    label: 'Name',
    numeric: false,
    disablePadding: false,
    id: 'name',
    sortable: true,
  },
  {
    label: 'Platform',
    numeric: false,
    disablePadding: false,
    id: 'platform__name',
    sortable: false,
  },
  {
    label: 'Email',
    numeric: false,
    disablePadding: false,
    id: 'email',
    sortable: true,
  },
  {
    label: 'Phone',
    numeric: false,
    disablePadding: false,
    id: 'phone',
    sortable: true,
  },
  {
    label: 'Lead Type',
    numeric: false,
    disablePadding: false,
    id: 'comment_type',
    sortable: true,
  },
  {
    label: 'Category',
    numeric: false,
    disablePadding: false,
    id: 'category',
    sortable: true,
  },
  // {
  //   label: 'Reply Sent',
  //   numeric: false,
  //   disablePadding: false,
  //   id: 'is_replied',
  //   sortable: true,
  // },
  // {
  //   label: 'User Location',
  //   numeric: false,
  //   disablePadding: false,
  //   id: 'about',
  //   sortable: true,
  // },
  {
    label: 'Client',
    numeric: false,
    disablePadding: false,
    id: 'sold_to_email',
    sortable: true,
  },

  {
    label: 'Comment',
    numeric: false,
    disablePadding: false,
    id: 'comment',
    sortable: true,
  },
  {
    label: 'Source',
    numeric: false,
    disablePadding: false,
    id: 'source',
    sortable: true,
  },
  {
    label: 'Sold On',
    numeric: false,
    disablePadding: false,
    id: 'sold_on',
    sortable: true,
  },
  {
    label: 'Generated At',
    numeric: false,
    disablePadding: false,
    id: 'created_at',
    sortable: true,
  },
  {
    label: 'Action',
    numeric: false,
    disablePadding: false,
    id: 'actions',
    sortable: false,
  },
];
const LeadDrawer = ({ open, setOpen }) => {
  const currentLead = useSelector((state) => state.leadReducer.currentLead)
  const commentDetail = currentLead?.platform_leads?.data
  const loadDrawer = useSelector((state) => state.leadReducer.loadDrawer)
  const [isPreviewImage, setIsPreviewImage] = useState(false)

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getFeedUrl = (commentDetail) => {
    if (!commentDetail) return "#";

    const { feed_type, video_id, reel_id, photo_id, group_id, page_id, post_id } = commentDetail;

    const feedUrlMap = {
      videos: video_id,
      post: post_id,
      reels: reel_id,
      photos: photo_id,
      "group_post": group_id,
      "page_post": page_id,
    };

    return feedUrlMap[feed_type] || "#";
  };
  let domainLink = []
  let attachedMessage = ""
  if (commentDetail?.is_replied && commentDetail?.attached_message) {
    attachedMessage = commentDetail?.attached_message
  } else {
    domainLink = currentLead?.platform_leads?.domains?.map((domain) => domain?.route)
  }
  console.log("domainLink", domainLink);

  return (
    <CommentDrawer {...{ open, setOpen }}  >
      <Box  >
        <Typography variant="h6" gutterBottom className="p-3">
          Lead Comment
        </Typography>
        <Divider />
        {loadDrawer && <Loader className='table-loader' />}
        {!loadDrawer &&
          <List>
            {commentDetail &&
              <div className='lead-form-scroller px-3'>
                <React.Fragment key={commentDetail.id}>
                  <ListItem alignItems="flex-start" className="p-0 pt-2">
                    <ListItemText
                      primary={
                        <>
                          {currentLead?.source === "Facebook" && (
                            <TableContainer component={Paper} className="mb-3">
                              <Table>
                                <TableBody>
                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Platform:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {currentLead?.platform_leads?.platform || "N/A"}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Comment Text:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {commentDetail.comment_text}
                                    </TableCell>
                                  </TableRow>
                                  {/* <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>AI Reply:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {commentDetail.ai_reply ? commentDetail.ai_reply : "N/A"}
                                    </TableCell>
                                  </TableRow>*/}
                                  <TableRow> 
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>{attachedMessage ? "Replied Link:" : "Domain Link:"}</Typography>
                                    </TableCell>
                                    {/* <TableCell className='td-keyval'>
                                      {domainLink?.length ?
                                        domainLink?.map((ele, index) =>
                                          <a href={ele} target="_blank" rel="noopener noreferrer" className='d-inline' >
                                            <Typography color='primary'  variant='body2'  >{index + 1}. {" "} </Typography>
                                            <Typography color='primary' style={{ textDecoration: 'underline' }} variant='body2'> {ele} </Typography>
                                          </a>) : <>{domainLink || "N/A" }</>
                                        }
                                    </TableCell> */}
                                    <TableCell className="td-keyval">
                                      {domainLink?.length ? (
                                        domainLink?.map((ele, index) => (
                                          <Box key={index} sx={{ wordBreak: 'break-all', mb: 0.5 }}>
                                            <a href={ele} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                                              <Typography component="span" color="primary" variant="body2">
                                                {index + 1}.{" "}
                                              </Typography>
                                              <Typography component="span" color="primary" variant="body2" sx={{ textDecoration: 'underline', wordBreak: 'break-all' }}>
                                                {ele}
                                              </Typography>
                                            </a>
                                          </Box>
                                        ))
                                      ) : (
                                        <>{
                                          attachedMessage ? <a href={attachedMessage} target="_blank" rel="noopener noreferrer" ><Typography component="span" color="primary" variant="body2" sx={{ textDecoration: 'underline' }} > {attachedMessage} </Typography></a>
                                            : "N/A"}</>
                                      )}
                                    </TableCell>

                                  </TableRow>
                                  {/* <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>{!commentDetail.is_replied ? "Reply sent:" : "Replied On:"}</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      <Box className="d-flex justify-content-between" alignItems="center">
                                        {!commentDetail.is_replied && <Typography variant="body2" >
                                          {"No"}
                                        </Typography>}
                                        {commentDetail?.replied_on && <Typography variant="body2" >
                                          {formatDate(commentDetail.replied_on)}
                                        </Typography>}
                                        {commentDetail?.is_replied && (
                                          <Link
                                            component="button"
                                            variant="body2"
                                            color="primary"
                                            underline="always"
                                            onClick={() => {
                                              if (commentDetail?.is_replied) setIsPreviewImage(true);
                                            }}
                                            sx={{
                                              outline: 'none',
                                              '&:focus': { outline: 'none' },
                                              '&:focus-visible': { outline: 'none' },
                                            }}
                                          >
                                            <Tooltip title="See Reply" arrow>
                                              <ImageOutlinedIcon />
                                            </Tooltip>
                                          </Link>
                                        )}
                                      </Box>
                                    </TableCell>
                                  </TableRow> */}
                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Keyword:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {currentLead.keyword || "N/A"}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>User Location:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {currentLead.about ? currentLead.about : "N/A"}
                                    </TableCell>
                                  </TableRow>
                                  {/* <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Reply Image:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                     
                                    </TableCell>
                                  </TableRow> */}
                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Post Location:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {currentLead?.post_location?.display_name ? currentLead?.post_location?.display_name : "N/A"}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Post URL:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {commentDetail.post_id ? <a
                                        href={commentDetail.post_id}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="router-link-color"
                                      >
                                        {commentDetail.post_id}
                                      </a> : "N/A"}
                                    </TableCell>
                                  </TableRow>

                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Comment User URL:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {commentDetail.comment_user_url ? <a
                                        href={commentDetail.comment_user_url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="router-link-color"
                                      >
                                        {commentDetail.comment_user_url}
                                      </a> : "N/A"}
                                    </TableCell>
                                  </TableRow>

                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Feed URL:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      <a
                                        href={getFeedUrl(commentDetail)}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="router-link-color"
                                      >
                                        {getFeedUrl(commentDetail)}
                                      </a>
                                    </TableCell>
                                  </TableRow>

                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Comment Status:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>{commentDetail.comment_status || "N/A"}</TableCell>
                                  </TableRow>

                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Feed Name:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      <Typography >{commentDetail.feed_name || "N/A"}</Typography>
                                    </TableCell>
                                  </TableRow>

                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Feed Type:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>{commentDetail.feed_type || "N/A"}</TableCell>
                                  </TableRow>

                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Comment ID:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {commentDetail.comment_id ? <a
                                        href={commentDetail.comment_id}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="router-link-color"
                                      >
                                        {commentDetail.comment_id}
                                      </a> : "N/A"}
                                    </TableCell>
                                  </TableRow>

                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Reply Comment ID:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {commentDetail?.reply_comment_id && commentDetail?.reply_comment_id !== "N/A" ? (
                                        <a
                                          href={commentDetail.reply_comment_id}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="router-link-color"
                                        >
                                          {commentDetail.reply_comment_id}
                                        </a>
                                      ) : (
                                        "N/A"
                                      )}
                                    </TableCell>
                                  </TableRow>
                                </TableBody>
                              </Table>
                            </TableContainer>
                          )}
                          {currentLead?.source === "YouTube" && (
                            <TableContainer component={Paper} className="mb-3">
                              <Table>
                                <TableBody>
                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Platform:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {currentLead?.platform_leads?.platform || "N/A"}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Comment Text:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {commentDetail.comment_text}
                                    </TableCell>
                                  </TableRow>

                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Keyword:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {currentLead.keyword || "N/A"}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Comment ID:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {commentDetail.comment_id || "N/A"}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Channel ID:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {commentDetail.channel_id || "N/A"}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Channel Author ID:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {commentDetail.author_channel_id || "N/A"}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Video Id:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {commentDetail.video_id || "N/A"}
                                    </TableCell>
                                  </TableRow>
                               
                                </TableBody>
                              </Table>
                            </TableContainer>
                          )}
                          {currentLead?.source === "Reddit" && (
                             <TableContainer component={Paper} className="mb-3">
                              <Table>
                                <TableBody>
                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Platform:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {currentLead?.platform_leads?.platform || "N/A"}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Comment Text:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {commentDetail.comment_text}
                                    </TableCell>
                                  </TableRow>

                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Keyword:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {currentLead.keyword || "N/A"}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Comment ID:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {commentDetail.comment_id || "N/A"}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Channel ID:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {commentDetail.channel_id || "N/A"}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Channel Author ID:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {commentDetail.author_channel_id || "N/A"}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Video Id:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {commentDetail.video_id || "N/A"}
                                    </TableCell>
                                  </TableRow>
                               
                                </TableBody>
                              </Table>
                            </TableContainer>
                          )}
                          {currentLead?.source === "Instagram" && (
                             <TableContainer component={Paper} className="mb-3">
                              <Table>
                                <TableBody>
                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Platform:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {currentLead?.platform_leads?.platform || "N/A"}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Comment Text:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {commentDetail.comment_text}
                                    </TableCell>
                                  </TableRow>

                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Keyword:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {currentLead.keyword || "N/A"}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Comment ID:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {commentDetail.comment_id || "N/A"}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell>
                                      <Typography className='table-detail-cells-head' variant='body2'>Reply Comment ID:</Typography>
                                    </TableCell>
                                    <TableCell className='td-keyval'>
                                      {commentDetail.reply_comment_id || "N/A"}
                                    </TableCell>
                                  </TableRow>
                                
                                </TableBody>
                              </Table>
                            </TableContainer>
                          )}
                        </>
                      }
                      secondary={
                        <Box mt={1}>
                          <Typography variant="body2" color="text.secondary">
                            Posted on: {formatDate(commentDetail.comment_timestamp)}
                          </Typography>
                        </Box>
                      }
                    />
                  </ListItem>
                </React.Fragment>
              </div>
            }
            {!currentLead?.platform_leads?.data && <Typography component='h6' className='not-fount-drawer ml-3'>No Details Found</Typography>}
          </List>}



        <Dialog
          open={isPreviewImage}
          onClose={() => setIsPreviewImage(false)}
          maxWidth="lg"
          fullWidth
          PaperProps={{
            style: {
              backgroundColor: 'transparent',
              boxShadow: 'none',
            },
          }}
        >
          <DialogContent
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: 0,
              backgroundColor: '#000',
            }}
          >
            {commentDetail?.image ? (
              <TransformWrapper>
                <TransformComponent>
                  <img
                    src={commentDetail.image}
                    alt="Preview"
                    style={{
                      maxWidth: '100%',
                      maxHeight: '90vh',
                      objectFit: 'contain',
                    }}
                  />
                </TransformComponent>
              </TransformWrapper>
            ) : (
              <>N/A</>
            )}
          </DialogContent>
        </Dialog>

      </Box>
      <Box className="drawer-footer m-3">
        <Button
          type="button"
          variant="outlined"
          color="primary"
          onClick={(e) => { e.stopPropagation();; setOpen(false) }}
          className="mt-2 mr-2"
        >
          close
        </Button>
      </Box>
    </CommentDrawer>
  )
}

const LeadActions = ({ lead, setSelectedLead }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const userPermission = useSelector((state) => state.userReducer.userPermission)
  const userRole = useSelector((state) => state.userReducer.userRole)
  const leadsPermissions = userPermission.find((perm) => perm.model_name === "leads")?.permissions || [];
  let canEdit = leadsPermissions.includes("change");
  let canDelete = leadsPermissions.includes("delete");
  canEdit = process.env.REACT_APP_ADMIN_ROLE === userRole || canEdit;
  canDelete = process.env.REACT_APP_ADMIN_ROLE === userRole || canDelete;

  const handleDelete = async (id) => {
    try {
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <>
      <Grid spacing={4} justifyContent={'flex-end'}>
        <Grid size={8} spacing={2}>
          <Box gap={2} display='flex' className="table-margin">
            <RemoveRedEyeOutlinedIcon className='link-color' />
          </Box>
          <Confirmation open={isOpen} setOpen={setIsOpen} msg={"Are you sure you want to delete this Lead"} yesClick={() => { handleDelete(lead.uuid); setIsOpen(false) }} />
        </Grid >
      </Grid >
    </>
  )
}
function EnhancedTableHead(props) {
  const { setOrdering, tabValue, orderingState, setOrderingState, onSelectAllClick, numSelected, rowCount } = props;

  const createSortHandler = (property) => (event) => {
    const orderData = orderingState;
    const exists = orderData?.find((item) => item.id === property);
    const updated = (() => {
      if (exists) {
        return orderData.map((item) =>
          item.id === property
            ? { ...item, order: item.order === "asc" ? "desc" : "asc" }
            : item
        );
      } else {
        return [...orderData, { id: property, order: "asc" }];
      }
    })();
    setOrderingState(updated);
  };

  useEffect(() => {
    const ordering = orderingState.map((item) => {
      return item.order === "asc" ? item.id : "-" + item.id;
    });
    console.log("ordering", ordering);

    if (ordering?.length) {
      setOrdering(ordering.join(","));
    }
  }, [orderingState]);

  const removeFilter = (property) => {
    const data = orderingState.filter((item) => item.id !== property);
    setOrderingState(data);
  };

  return (
    <TableHead >
      <TableRow>
        {tabValue === 0 && <TableCell padding="checkbox">
          <Checkbox
            size='small'
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              "aria-label": "select all leads",
            }}
          />
        </TableCell>}
        {headCells.map((headCell) => {
          const key = headCell.id;
          if ((key === "sold_to_email" || key === "sold_on") && tabValue !== 1) {
            return null;
          }
          // const isSupported=headCell.supportedPlatform.find()
          const sortObj = orderingState.find((item) => item.id === key);
          const isSorted = !!sortObj;
          const sortDirection = sortObj?.order || "asc";

          return (
            <TableCell

              className="font-weight tablecell-padding"
              key={key}
              align={headCell.numeric ? "left" : "left"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={isSorted ? sortDirection : false}
            >
              {headCell.sortable ? (
                <TableSortLabel
                  active={isSorted}
                  direction={sortDirection}
                  onClick={createSortHandler(key)}
                  color="secondary"
                  hideSortIcon={false}
                >
                  {headCell.label}
                  {isSorted && (
                    <Box component="span" sx={visuallyHidden}>
                      {sortDirection === "desc" ? "sorted descending" : "sorted ascending"}
                    </Box>
                  )}
                  {isSorted && (
                    <FilterListOffIcon
                      onClick={(e) => {
                        e.stopPropagation();
                        removeFilter(headCell.id);
                      }}
                      className="ml-2"
                      size="small"
                      color="primary"
                    />
                  )}
                </TableSortLabel>
              ) : (
                headCell.label
              )}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}
function EnhancedTableToolbar(props) {
  const [open, setOpen] = React.useState(false)
  const [title, setTitle] = React.useState("")
  const { integration, setIntegration, setPage, currentLocations, setCurrentLocations, currentDomain, setCurrentDomain, tabValue, isFilterClicked, setIsFilterClicked, curretReplyType, setCurrentReplyType, applyFilter, setTabValue, numSelected, currentPlatform, platforms, handleChange, currentIndustry, setCurrentIndustry, handlePlatformChange, handleLeadTypeChange, industries, rowsPerPage, currentLeadType, handleFeedTypeChange, currentFeedType, handleSelectAllClick, selected, setSelected, setCurrentFeedType, setCurrentLeadType, setCurrentPlatform ,leadCategory, setLeadCategory} = props;

  return (
    <>
      <Toolbar
        className='main-list-toolbar'
      >
        <Typography
          className="d-flex flex-grow-1 flex-shrink-1 flex-fill"
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Scrapped
        </Typography>
        {tabValue === 0 && <Tooltip title="Export">
          <Button
            className='mr-2'
            variant="contained"
            onClick={() => {
              setTitle("Export Leads");
              setIsFilterClicked(false);
              setOpen(true);
            }}
          >
            Export
          </Button>
        </Tooltip>}
        <Tooltip title="Filter">
          <Button
            variant="contained"
            onClick={() => {
              setTitle("Apply Filter");
              setIsFilterClicked(true);
              setOpen(true);
            }}
          >
            Filter
          </Button>
        </Tooltip>
      </Toolbar>
      <CommentDrawer {...{ open, setOpen }} className="p-3" >
        <LeadExport {...{ leadCategory, setLeadCategory,integration, setIntegration,setPage, currentLocations, setCurrentLocations, currentDomain, setCurrentDomain, numSelected, selected, setSelected, tabValue, isFilterClicked, open, applyFilter, setTabValue, setOpen, title, handleFeedTypeChange, setCurrentReplyType, curretReplyType, currentLeadType, setCurrentLeadType, handleLeadTypeChange, currentIndustry, setCurrentIndustry, handleChange, industries, currentPlatform, setCurrentPlatform, currentFeedType, setCurrentFeedType, handlePlatformChange, handleSelectAllClick }} intialLeadCount={rowsPerPage} />
      </CommentDrawer>

    </>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};
EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function LeadManage() {
  const platforms = useSelector((state) => state.platformReducer.platformList)
  const industries = useSelector((state) => state.industryReducer.industries)
  const leadData = useSelector((state) => state.leadReducer.leadData)
  const leadCount = useSelector((state) => state.leadReducer.leadCount)
  const loading = useSelector((state) => state.leadReducer.loading)
  const [ordering, setOrdering] = React.useState();
  const [orderingState, setOrderingState] = useState([])
  const location = useLocation();
  const [selected, setSelected] = React.useState([]);
  const [rows, setRows] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [selectedLead, setSelectedLead] = React.useState(0);
  const [currentPlatform, setCurrentPlatform] = useState([]);
  const [currentDomain, setCurrentDomain] = useState([]);
  const [currentLocations, setCurrentLocations] = useState([]);
  const [currentIndustry, setCurrentIndustry] = useState([]);
  const [currentLeadType, setCurrentLeadType] = useState(0);
  const [currentFeedType, setCurrentFeedType] = useState(0);
  const [isFilterClicked, setIsFilterClicked] = useState(false);
  const [curretReplyType, setCurrentReplyType] = useState("all");
  const [leadCategory, setLeadCategory] = useState([]);
  const [integration, setIntegration] = useState([]);
  const [leadSectiontype, setLeadSectiontype] = useState(0);

  const [tabValue, setTabValue] = React.useState(0);
  const dispatch = useDispatch()
  const [rowsPerPage, setRowsPerPage] = React.useState(ROWS_PER_PAGE);


  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.uuid); // Select all names
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, uuid) => {
    const selectedIndex = selected.indexOf(uuid);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, uuid);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  const applyFilter = (sold_to, type) => {
    const updatedPlatform = currentPlatform.filter((item) => item !== 'all')
    const updatedLocation = currentLocations.filter((item) => item !== 'all')
    const data = {
      platform_id: updatedPlatform?.join(","),
      industry_id: currentIndustry?.join(","),
      comment_type: currentLeadType,
      location: updatedLocation,
      category: leadCategory?.filter(i => i !== 'all').join(","),
      feed_type: currentFeedType,
      page: type === "filter" ? 1 : page + 1,
      page_size: rowsPerPage,
      source: integration?.filter(i => i !== 'all').join(","),
      is_sold: tabValue ? true : false,
      sold_to: sold_to && Array.isArray(sold_to) ? sold_to.join(",") : sold_to,
      is_replied: curretReplyType === "all" ? "all" : curretReplyType ? true : false,
      ordering
    }
    dispatch(fetchLeadData(data)).then(() => {
      setSelected([])
      if (type === "filter")
        setPage(0)
    })
  }

  useEffect(() => {
    let updatedPlatform = currentPlatform.filter((item) => item !== 'all')
    if (!updatedPlatform.length) {
      updatedPlatform = [location.state?.platform];
    }
    const updatedLocation = currentLocations.filter((item) => item !== 'all')
    const data = {
      platform_id: updatedPlatform.join(","),
      industry_id: currentIndustry.join(","),
      comment_type: currentLeadType,
      location: updatedLocation,
      category: leadCategory?.filter(i => i !== 'all').join(","),
      feed_type: currentFeedType,
      source: integration?.filter(i => i !== 'all').join(","),
      page: page + 1,
      is_sold: tabValue ? true : false,
      page_size: rowsPerPage,
      is_replied: curretReplyType === "all" ? "all" : curretReplyType ? true : false,
      ordering
    }
    dispatch(fetchLeadData(data))
  }, [tabValue, page, rowsPerPage, ordering])

  useEffect(() => {
    if (currentIndustry?.length || integration?.length) {
      // Filter out 'all' and empty values from integration
      const filteredIntegrations = (integration || []).filter(i => i && i !== 'all');
      dispatch(fetchPlatformsList({
        industry_id: currentIndustry.join(","),
        queryString: filteredIntegrations.length ? `&integration=${filteredIntegrations.join(",")}` : ""
      }))
    }
  }, [currentIndustry, integration])

  useEffect(() => {
    dispatch(fetchPlatformsList())
    dispatch(fetchIndustryList())
    dispatch(fetchClientList())
    const platformFromURL = location.state?.platform;

    if (platformFromURL) {
      setCurrentPlatform([platformFromURL]);
    }
  }, [])

  React.useEffect(() => {
    const rowData = leadData?.map((ele) => createData(ele.uuid, ele.id, ele.name, ele?.platform_leads?.platform, ele.email, ele.phone, ele?.comment_type, ele?.category, ele?.platform_leads?.data?.comment_text, ele?.client?.email, ele?.platform_leads?.data?.is_replied, ele.about, formatDate(ele?.client?.sold_on), ele?.source, formatDate(ele.created_at), <LeadActions {...{ setSelectedLead, currentPlatform }} lead={ele} />))
    setRows(rowData)
  }, [leadData])

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handlePlatformChange = (event) => {
    const value = event.target.value;
    setCurrentPlatform(value)
  };
  const handleLeadTypeChange = (event) => {
    const value = event.target.value;
    setCurrentLeadType(value)
  };
  const handleFeedTypeChange = (event) => {
    const value = event.target.value;
    setCurrentFeedType(value)
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleChange = (event) => {
    const value = event.target.value;
    setCurrentIndustry(value);
  };

  const LeadTableRow = ({
    row,
    index,
    tabValue,
    isSelected,
    handleClick,
    dispatch,
    fetchLeadById,
  }) => {
    const isItemSelected = isSelected(row.uuid);
    const [openLeadDetail, setOpenLeadDetail] = useState(false)
    const handleRowClick = (event) => {
      event.stopPropagation();
      dispatch(fetchLeadById({ id: row.id, platform: row?.source }));
      setOpenLeadDetail(true);
    };

    return (
      <>
        <TableRow
          hover
          role="checkbox"
          aria-checked={isItemSelected}
          tabIndex={-1}
          key={row.id}
          selected={isItemSelected}
          className="btn"
          onClick={handleRowClick}
        >

          {tabValue === 0 && (
            <TableCell padding="checkbox" onClick={(event) => handleClick(event, row.uuid)}>
              <Checkbox
                size="small"
                color="primary"
                checked={isItemSelected}
                inputProps={{
                  "aria-labelledby": `enhanced-table-checkbox-${index}`,
                }}
              />
            </TableCell>
          )}
          <TableCell align="left" className="tablecell-padding" sx={{ minWidth: '155px' }}>
            {row?.name ? (
              row.name.length > 13 ? (
                <Tooltip title={capitalizeWords(row.name)} arrow>
                  <span>{capitalizeWords(row.name.slice(0, 13))}...</span>
                </Tooltip>
              ) : (
                <span>{capitalizeWords(row.name)}</span>
              )
            ) : (
              "N/A"
            )}
          </TableCell>
          <TableCell align="left" className="no-wrap tablecell-padding" sx={{ minWidth: '160px' }}>
            {row?.platform ? (
              row.platform.length > 13 ? (
                <Tooltip title={row.platform} arrow>
                  <span>{row.platform.slice(0, 13)}...</span>
                </Tooltip>
              ) : (
                <span>{row.platform}</span>
              )
            ) : (
              "N/A"
            )}
          </TableCell>
          <TableCell align="left" className="no-wrap tablecell-padding" sx={{ minWidth: '160px' }}>
            {row?.email ? (
              row.email.length > 14 ? (
                <Tooltip title={row.email} arrow>
                  <span>{row.email.slice(0, 14)}...</span>
                </Tooltip>
              ) : (
                <span>{row.email}</span>
              )
            ) : (
              "N/A"
            )}
          </TableCell>
          <TableCell className="no-wrap tablecell-padding" align="left" sx={{ minWidth: '150px' }}>{row.phone || "N/A"}</TableCell>
          <TableCell className="no-wrap tablecell-padding" align="left">{row?.leadType || "N/A"}</TableCell>
          <TableCell className="no-wrap tablecell-padding" align="left">{row?.cateory || "N/A"}</TableCell>
          {/* <TableCell className="no-wrap tablecell-padding" align="left">{row?.replySent ? "Yes" : "No"}</TableCell> */}
          {/* <TableCell className="no-wrap tablecell-padding" align="left">
            {row?.location ? (
              row.location.length > 10 ? (
                <Tooltip title={row.location} arrow>
                  <span>{row.location.slice(0, 10)}...</span>
                </Tooltip>
              ) : (
                <span>{row.location}</span>
              )
            ) : (
              "N/A"
            )}
          </TableCell> */}
          {tabValue === 1 && (
            <TableCell className="no-wrap tablecell-padding" align="left">
              {row?.client ? (
                <Tooltip title={row.client} arrow disableHoverListener={row.client.length <= 15}>
                  <span>
                    {row.client.slice(0, 15)}
                    {row.client.length > 15 ? '…' : ''}
                  </span>
                </Tooltip>
              ) : (
                "N/A"
              )}
            </TableCell>
          )}
          <TableCell align="left" className="no-wrap tablecell-padding" sx={{ minWidth: '180px' }}>
            {row?.commentText ? (
              row.commentText.length > 20 ? (
                <Tooltip title={row.commentText} arrow>
                  <span>{row.commentText.slice(0, 18)}...</span>
                </Tooltip>
              ) : (
                <span>{row.commentText}</span>
              )
            ) : (
              "N/A"
            )}
          </TableCell>
          <TableCell className="no-wrap tablecell-padding" align="left">{row.source}</TableCell>

          {tabValue === 1 && (
            // <TableCell sx={{ maxWidth: '165px' }} align="left">{row.soldOn || "N/A"}</TableCell>
            <TableCell className="no-wrap tablecell-padding" align="left">
              {row.soldOn ? (
                <Tooltip title={row.soldOn} arrow disableHoverListener={row.soldOn.length <= 9}>
                  <span>
                    {row.soldOn.slice(0, 9)}
                    {row.soldOn.length > 9 ? '…' : ''}
                  </span>
                </Tooltip>
              ) : (
                "N/A"
              )}
            </TableCell>
          )}
          <TableCell className="no-wrap tablecell-padding" align="left">{row.createdat}</TableCell>
          <TableCell className="no-wrap" align="left">{row.actions}</TableCell>
        </TableRow>
        <LeadDrawer open={openLeadDetail} setOpen={setOpenLeadDetail} />
      </>
    );
  };

  return (
    <>
      <Paper className="w-100 mb-2" >
        <EnhancedTableToolbar handleSelectAllClick={handleSelectAllClick} selected={selected} numSelected={selected?.length} {...{ integration, setIntegration,currentLocations, setPage, setCurrentLocations, currentDomain, setCurrentDomain, leadSectiontype, setSelected, setLeadSectiontype, tabValue, isFilterClicked, setIsFilterClicked, applyFilter, setTabValue, curretReplyType, setCurrentReplyType, currentPlatform, platforms, handleChange, handlePlatformChange, currentIndustry, setCurrentIndustry, setCurrentPlatform, currentLeadType, handleLeadTypeChange, industries, rowsPerPage, handleFeedTypeChange, currentFeedType,leadCategory, setLeadCategory }} />
        {loading && <LinearProgress />}
        <CommonTabs {...{ tabValue, setTabValue, setPage }} >
          <TableContainer className='position-relative'>
            <Table
              className='min-width-750 table-container'
              aria-labelledby="tableTitle"
              size={'small'}
            >
              <EnhancedTableHead
                tabValue={tabValue}
                setOrdering={setOrdering}
                orderingState={orderingState}
                setOrderingState={setOrderingState}
                numSelected={selected.length}
                onSelectAllClick={handleSelectAllClick}
                rowCount={rows?.length}
              />
              <TableBody>
                {rows?.map((row, index) => (
                  <LeadTableRow
                    key={row.id}
                    row={row}
                    index={index}
                    tabValue={tabValue}
                    isSelected={isSelected}
                    handleClick={handleClick}
                    dispatch={dispatch}
                    fetchLeadById={fetchLeadById}
                  />
                ))}
              </TableBody>
            </Table>
            {!leadData?.length && !loading && <NoData></NoData>}
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            component="div"
            count={leadCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </CommonTabs>
      </Paper>

    </>
  )
}

export default LeadManage